import { PF21_NAICS_CODES_BY_CATEGORY, PF21_NAICS_CODES_SORTED } from '@/data/naics'

// Onboarding package prices are NOT mirrored here. They are quoted per draft by
// ProductData (`GET /api/customer/onboarding/quote`), which reads the live Stripe
// amounts for the exact price ids checkout will use. The table that used to live
// here had no shareholder-count dimension, so it showed multi-member LLCs the
// single-member rate they were not charged.
export const DEFAULT_TOTAL_SHARES = 10_000_000

export const SUPPORT_EMAIL = 'support@nonresident.tax'

export const TAX_ID_TYPE_FORMAT = {
  SSN: '###-##-####',
  ITIN: '###-##-####',
  EIN: '##-#######',
}

export const TAX_ID_TYPE_LABEL = {
  SSN: 'Social Security Number',
  ITIN: 'Individual Taxpayer Identification Number',
  EIN: 'Employer Identification Number',
  FTIN: 'Foreign Tax Identification Number',
}

export const NAICS_CODES = PF21_NAICS_CODES_SORTED
const _NAICS_CODES_BY_CATEGORY = PF21_NAICS_CODES_BY_CATEGORY
